import type { AllPlace } from '#/routes/-queries';

export const REELS_PER_PAGE = 18;

export type PaginatedReels = {
  places: AllPlace[];
  currentPage: number;
  totalPages: number;
  totalCount: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  featuredPlace: AllPlace | null;
};

export function paginateLatestReels(
  places: AllPlace[],
  requestedPage: number,
  perPage = REELS_PER_PAGE,
): PaginatedReels {
  const reelPlaces = places
    .filter(
      (
        place,
      ): place is AllPlace & {
        latestReel: NonNullable<AllPlace['latestReel']>;
      } => place.latestReel !== null,
    )
    .toSorted((left, right) => {
      const leftPublishedAt = left.latestReel.publishedAt;
      const rightPublishedAt = right.latestReel.publishedAt;

      if (leftPublishedAt === null) return rightPublishedAt === null ? 0 : 1;
      if (rightPublishedAt === null) return -1;
      return rightPublishedAt.localeCompare(leftPublishedAt);
    });
  const totalPages = Math.max(1, Math.ceil(reelPlaces.length / perPage));
  const currentPage = Math.min(Math.max(1, requestedPage), totalPages);
  const offset = (currentPage - 1) * perPage;

  return {
    places: reelPlaces.slice(offset, offset + perPage),
    currentPage,
    totalPages,
    totalCount: reelPlaces.length,
    hasPreviousPage: currentPage > 1,
    hasNextPage: currentPage < totalPages,
    featuredPlace: reelPlaces[0] ?? null,
  };
}
